import React from 'react';
import { Button, Chip, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { KnowledgeBaseFileRow } from '@features/Admin/KnowledgeBase/ui/KnowledgeBaseFileRow';
import type { CampaignKnowledgeBaseFile } from '@features/Admin/KnowledgeBase/model/types';

type Props = {
  file: CampaignKnowledgeBaseFile;
  onDetails: (fileId: string) => void;
};

export const AgentFileCard: React.FC<Props> = ({ file, onDetails }) => {
  const { t } = useTranslation();

  return (
    <KnowledgeBaseFileRow
      file={file}
      metadataDate="createdAt"
      cardProps={{
        sx: (theme) => ({
          width: '100%',
          borderRadius: theme.shape.borderRadius,
          boxShadow: theme.shadows[0],
        }),
      }}
      contentProps={{
        sx: (theme) => ({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          minWidth: 0,
          p: 1.5,
          '&:last-child': { pb: 1.5 },
          [theme.breakpoints.down('sm')]: {
            alignItems: 'stretch',
            flexDirection: 'column',
          },
        }),
      }}
      infoProps={{ sx: { minWidth: 0 } }}
      titleProps={{ variant: 'subtitle2' }}
      metadataProps={{ noWrap: true }}
      actions={
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          useFlexGap
          flexWrap="wrap"
          gap={1}
          flexShrink={0}>
          <Chip
            size="small"
            label={t('campaignPage.knowledgeBase.availability.enabled')}
            color="primary"
            variant="outlined"
          />
          <Button size="small" variant="contained" onClick={() => onDetails(file.id)}>
            {t('campaignPage.knowledgeBase.actions.details')}
          </Button>
        </Stack>
      }
    />
  );
};
